import React from 'react'

type Props = {
  width?: number
  height?: number
}

export function CardsIconDiscover({ width = 37, height = 24 }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 37 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M36.9231 24H0V1.90735e-06H36.9231V24Z" fill="#EEEEEE" />
      <path
        d="M36.9229 12.5816C36.9229 12.5816 25.745 20.47 5.27148 24H36.9229V12.5816Z"
        fill="#EB8518"
      />
      <path
        d="M5.30966 8.76513C5.00678 9.03882 4.61376 9.15707 3.99032 9.15707H3.73178V5.8903H3.99032C4.61376 5.8903 4.99128 6.00208 5.30966 6.28981C5.64284 6.58685 5.84332 7.0459 5.84332 7.52008C5.84332 7.99427 5.64284 8.46735 5.30966 8.76513ZM4.18358 5.05261H2.76904V9.99365H4.17674C4.9253 9.99365 5.46471 9.81762 5.93996 9.42282C6.50318 8.95768 6.83635 8.25384 6.83635 7.52618C6.83635 6.06873 5.74705 5.05261 4.18358 5.05261Z"
        fill="#333333"
      />
      <path
        d="M7.38818 9.99365H8.35272V5.05261H7.38818V9.99365Z"
        fill="#333333"
      />
      <path
        d="M11.1143 6.94818C10.536 6.73477 10.3658 6.59307 10.3658 6.32621C10.3658 6.01504 10.6679 5.77883 11.0837 5.77883C11.3725 5.77883 11.6095 5.89717 11.86 6.17944L12.3644 5.51926C11.9513 5.15612 11.4547 4.97114 10.9128 4.97114C10.0387 4.97114 9.37164 5.57806 9.37164 6.38751C9.37164 7.06717 9.68253 7.41517 10.5879 7.74147C10.9651 7.87486 11.1569 7.96329 11.2546 8.02347C11.4461 8.14892 11.5423 8.32744 11.5423 8.53403C11.5423 8.93391 11.2247 9.23067 10.7945 9.23067C10.3344 9.23067 9.96444 9.00101 9.74271 8.57261L9.11963 9.17114C9.56456 9.82274 10.0975 10.1123 10.8313 10.1123C11.8327 10.1123 12.535 9.44704 12.535 8.49037C12.535 7.70437 12.2105 7.34917 11.1143 6.94818Z"
        fill="#333333"
      />
      <path
        d="M12.9019 7.52621C12.9019 8.97867 14.0427 10.1055 15.5102 10.1055C15.9249 10.1055 16.2811 10.0243 16.7181 9.81765V8.68291C16.3324 9.06765 15.9919 9.22384 15.5553 9.22384C14.5843 9.22384 13.8952 8.52073 13.8952 7.52011C13.8952 6.57174 14.6056 5.82285 15.5102 5.82285C15.97 5.82285 16.3183 5.98661 16.7181 6.37891V5.24482C16.2948 5.0303 15.9469 4.94085 15.5326 4.94085C14.073 4.94085 12.9019 6.08935 12.9019 7.52621Z"
        fill="#333333"
      />
      <path
        d="M24.3595 8.37086L23.0426 5.0524H21.9897L24.0858 10.1196H24.605L26.7385 5.0524H25.6946L24.3595 8.37086Z"
        fill="#333333"
      />
      <path
        d="M27.1748 9.99365H29.9079V9.15707H28.1375V7.82405H29.8431V6.98645H28.1375V5.8903H29.9079V5.05261H27.1748V9.99365Z"
        fill="#333333"
      />
      <path
        d="M31.7906 7.32827H31.5087V5.83076H31.8061C32.4047 5.83076 32.731 6.08313 32.731 6.5635C32.731 7.0603 32.4047 7.32827 31.7906 7.32827ZM33.7237 6.51116C33.7237 5.58735 33.0862 5.05261 31.9756 5.05261H30.5459V9.99365H31.5087V8.00978H31.6349L32.9671 9.99365H34.1535L32.5976 7.91202C33.3242 7.76415 33.7237 7.26836 33.7237 6.51116Z"
        fill="#333333"
      />
      <path
        d="M22.1086 7.55581C22.1086 8.99092 20.9457 10.1538 19.5106 10.1538C18.0759 10.1538 16.9131 8.99092 16.9131 7.55581C16.9131 6.11969 18.0759 4.9579 19.5106 4.9579C20.9457 4.9579 22.1086 6.11969 22.1086 7.55581Z"
        fill="#EB8518"
      />
    </svg>
  )
}
